<template>
  <div
    v-if="relation && render"
    :class="$style.root"
  >
    {{ $t('shared.relatedTo') }}
    <i18nLink
      :to="{ name: 'exhibitions-slug', params: { slug: relation?.slug } }"
      :locale="relationLocaleIsoCode"
      class="link"
    >
      {{ relation?.title }}
    </i18nLink>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  attributes: Object
})

const relation = props?.attributes?.exhibitionEntry?.data?.attributes
const relationLocaleIsoCode = baseI18nGetCodeForIso(relation)

const nuxtApp = useNuxtApp()
const routeName = nuxtApp.$getRouteBaseName()

const render = routeName != 'exhibitions-slug'

</script>

<style module>
.root {
  composes: font-helvetica font-size-small from global;
}
</style>
